import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon';
import ArrowRightIcon from '@/components/icons/ArrowRightIcon';
import { Button } from '@/components/ui/button';
import { FC } from 'react';
import { addMonths, addYears, format, subMonths, subYears } from 'date-fns';
import { useCalendarFilter } from '@/features/calendar/hooks/useCalendarFilter';
import { cn } from '@/lib/utils';

type Props = {
	viewMode: 'month' | 'year';
	selectedDate: Date;
	setSelectedDate: (date: Date) => void;
	containerClassName?: string;
	isMobile?: boolean;
};

const CalendarPeriodSelector: FC<Props> = ({
	viewMode,
	selectedDate,
	setSelectedDate,
	containerClassName,
	isMobile
}) => {
	const { resetFilter } = useCalendarFilter();

	const previousPeriodHandler = () => {
		resetFilter();
		setSelectedDate(
			viewMode === 'month'
				? subMonths(selectedDate, 1)
				: subYears(selectedDate, 1),
		);
	};

	const nextPeriodHandler = () => {
		resetFilter();
		setSelectedDate(
			viewMode === 'month'
				? addMonths(selectedDate, 1)
				: addYears(selectedDate, 1),
		);
	};

	return (
		<div
			className={cn(
				'h-11 shrink-0 flex border border-popover-100 rounded-semi-xl bg-popover-10 overflow-hidden',
				containerClassName,
			)}>
			<Button
				variant={'outline'}
				className='size-[42px] shrink-0 border-none border-popover-100 rounded-none hover:shadow-none hover:bg-primary-color-50'
				onClick={previousPeriodHandler}>
				<ArrowLeftIcon />
			</Button>
			<div className={cn('w-full min-w-24 flex items-center justify-center border-x border-popover-100', isMobile && 'min-w-auto flex-1')}>
				<span className='text-sm font-medium'>
					{viewMode === 'month'
						? format(selectedDate, 'MMM yyyy')
						: format(selectedDate, 'yyyy')}
				</span>
			</div>
			<Button
				variant={'outline'}
				className='size-[42px] shrink-0 border-none border-popover-100 rounded-none hover:shadow-none hover:bg-primary-color-50'
				onClick={nextPeriodHandler}>
				<ArrowRightIcon />
			</Button>
		</div>
	);
};

export default CalendarPeriodSelector;
